import React from 'react';
import PropTypes from 'prop-types';
import '../styles/lineup.css';

const ColumnVisibilityBar = ({
  offerActive,
  forecastActive,
  actualsActive,
  onToggleColumn,
}) => {
  return (
    <div className="column-visibility-bar">
      <button
        type="button"
        className={`column-visibility-bar__btn${offerActive ? ' column-visibility-bar__btn--active' : ''}`}
        onClick={() => onToggleColumn('offer')}
      >
        Offer
      </button>
      <button
        type="button"
        className={`column-visibility-bar__btn${forecastActive ? ' column-visibility-bar__btn--active' : ''}`}
        onClick={() => onToggleColumn('forecast')}
      >
        Forecast
      </button>
      <button
        type="button"
        className={`column-visibility-bar__btn${actualsActive ? ' column-visibility-bar__btn--active' : ''}`}
        onClick={() => onToggleColumn('actuals')}
      >
        Actuals
      </button>
    </div>
  );
};

ColumnVisibilityBar.propTypes = {
  offerActive: PropTypes.bool.isRequired,
  forecastActive: PropTypes.bool.isRequired,
  actualsActive: PropTypes.bool.isRequired,
  onToggleColumn: PropTypes.func.isRequired,
};

export default ColumnVisibilityBar;
